// URL por defecto solo para desarrollo local (mismo host/puerto que WebApiBosch en launchSettings).
const DEFAULT_API_BASE_URL = 'http://localhost:5000/api';

const normalizeBaseUrl = (value?: string) => value?.replace(/\/+$/, '');

export const API_BASE_URL_DEV = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL_DEV);
export const API_BASE_URL_PROD = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);
export const API_BASE_URL = API_BASE_URL_PROD || API_BASE_URL_DEV || DEFAULT_API_BASE_URL;

// Otras constantes de configuración
export const API_TIMEOUT = 30000; // 30 segundos
export const POLLING_INTERVAL = 3000; // 3 segundos
export const MAX_POLLING_ATTEMPTS = 20;
